import Faqs from "./Faqs";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import LocationModel from "../components/booking/LocationModel";
import Meta from "../components/common/Meta";
import useMeta from "../hooks/useMeta";
import MadeSimpleSection from "../components/sections/MadeSimpleSection";
import { applyBookingAvailabilityPayload } from "../utils/bookingLeadTime";
import axios from "axios";
import Swal from "../utils/swal";

const Home = () => {
  const navigate = useNavigate();
  const [pendingBookingPath, setPendingBookingPath] = useState(null);
  const [newBookingEnabled, setNewBookingEnabled] = useState(true);

  const goBooking = (path) => {
    if (!newBookingEnabled) {
      Swal.fire({
        title: "Not Available",
        text: "New bookings are temporarily unavailable. Please try again later.",
        icon: "warning",
      });
      return;
    }
    if (localStorage.getItem("selectedCityId")) {
      navigate(path);
      return;
    }
    setPendingBookingPath(path);
    const el = document.getElementById("locationModal");
    if (el && window.bootstrap) {
      window.bootstrap.Modal.getOrCreateInstance(el).show();
    }
  };

  useEffect(() => {
    let isMounted = true;
    const fetchBookingAvailability = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_APP_DOMAIN}/api/customer/booking-availability`
        );
        if (!isMounted) return;
        applyBookingAvailabilityPayload(response?.data);
        setNewBookingEnabled(Boolean(response?.data?.new_booking_enabled));
      } catch {
        if (!isMounted) return;
        setNewBookingEnabled(true);
      }
    };

    fetchBookingAvailability();
    return () => {
      isMounted = false;
    };
  }, []);

  const meta = useMeta("home");
  return (
    <>
      {meta && (
        <Meta
          title={meta.meta_title}
          description={meta.meta_description}
          keywords={meta.meta_keywords}
        />
      )}
      <section className="banner_wrap">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="banner_content">
                <h1 className="wow fadeInLeft" data-wow-duration="1s">
                  Pre-Book Your Cabs
                  <br />
                  for Airport, City &amp; Outstation Trips
                </h1>
                <div className="tour_buttons">
                  <a
                    href="#!"
                    onClick={(e) => {
                      e.preventDefault();
                      goBooking("/booking/airport");
                    }}
                  >
                    <img src="assets/img/all-images/plane-icon.png" alt="" />{" "}
                    Airport Transfers
                  </a>
                  <a
                    href="#!"
                    onClick={(e) => {
                      e.preventDefault();
                      goBooking("/booking/city");
                    }}
                  >
                    <img src="assets/img/all-images/city-icon.png" alt="" />{" "}
                    City Tours
                  </a>
                  <a
                    href="#!"
                    onClick={(e) => {
                      e.preventDefault();
                      goBooking("/booking/outstation");
                    }}
                  >
                    <img src="assets/img/all-images/trip-icon.png" alt="" />{" "}
                    Outstation Trip
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container">
        <div
          className="app_links mobile_app_links wow fadeInLeft d-md-none d-flex"
          data-wow-duration="3s"
        >
          <Link
            to="#"
            onClick={(e) => e.preventDefault()}
            data-bs-toggle="modal"
            data-bs-target="#playStoreModal"
          >
            <img
              src="assets/img/all-images/android-btn.png"
              alt="Download on Google Play"
            />
          </Link>
          <Link
            to="#"
            onClick={(e) => e.preventDefault()}
            data-bs-toggle="modal"
            data-bs-target="#appStoreModal"
          >
            <img
              src="assets/img/all-images/apple-btn.png"
              alt="Download on the App Store"
            />
          </Link>
        </div>
      </div>
      <MadeSimpleSection />

      <section className="whyChoose_wrap section_mt">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="titles">
                <h2 className="wow fadeInLeft">Why Choose ORBI?</h2>
                <p className="wow fadeInRight">
                  Every ride comes with the reliability and professionalism you
                  expect from a trusted travel partner.
                </p>
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-4 col-md-12 col-12 d-lg-block d-none">
              <div className="whyChoose_image wow fadeInLeft">
                <img
                  src="assets/img/all-images/mobile-frame-new.png"
                  alt="Mobile app mockup showing the Orbi app"
                />
              </div>
            </div>
            <div className="col-lg-8 col-md-12 col-12">
              <div className="row g-4">
                <div className="col-lg-6 col-md-6 col-12">
                  <div
                    className="why_col wow fadeInRight"
                    data-wow-duration="1s"
                  >
                    <img
                      src="assets/img/all-images/Heading-1.png"
                      alt="Pre-booked reliability icon"
                    />
                    <h3>Pre-Booked Reliability</h3>
                    <p>Your cab, always confirmed and ready when you need.</p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-12">
                  <div
                    className="why_col wow fadeInRight"
                    data-wow-duration="2s"
                  >
                    <img
                      src="assets/img/all-images/Heading-2.png"
                      alt="Professional fleets icon"
                    />
                    <h3>Professional Fleets</h3>
                    <p>
                      Trusted transport partners, never random freelancers or
                      unsafe drivers.
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-12">
                  <div
                    className="why_col wow fadeInRight"
                    data-wow-duration="1s"
                  >
                    <img
                      src="assets/img/all-images/Heading-3.png"
                      alt="No surge and cancellation icon"
                    />
                    <h3>No Surge & Cancellation</h3>
                    <p>
                      Transparent pricing every single ride, guaranteed fair.
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-12">
                  <div
                    className="why_col wow fadeInRight"
                    data-wow-duration="2s"
                  >
                    <img
                      src="assets/img/all-images/Heading-4.png"
                      alt="Human Support icon"
                    />
                    <h3>Human Support</h3>
                    <p>
                      Empathetic human support on WhatsApp, calls, and e-mail.
                      No bots, no spam.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Faqs className="section_mt" />

      <LocationModel
        navigateToAfterSelect={pendingBookingPath}
        onNavigateConsumed={() => setPendingBookingPath(null)}
      />
    </>
  );
};

export default Home;
